import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Accordion} from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import StatusBadge from "./StatusBadge";
import AcceptReject from "./AcceptReject";
import {useWatch} from "react-hook-form";
import AddFieldList from "./AddFieldList";
import EnhancedAccordionBody from "../../../components/common/EnhancedAccordionBody";

const AddAccordionItem = ({
                              index,
                              controlId,
                              properties,
                              header,
                              effectiveDate,
                              hiddenPropertyNames = [],
                              displayOnlyPropertyNames = [],
                              predefinedOptionProperties = [],
                              ...props
                          }) => {
    const status = useWatch({name: controlId + ".status"})
    const { activeEventKey } = useContext(AccordionContext);
    return (
        <Accordion.Item eventKey={index.toString()}>
            <Accordion.Header>
                Add : {header} as of {effectiveDate}
                <StatusBadge status={status} />
            </Accordion.Header>
            <EnhancedAccordionBody createChildren={"whenExpanded"}>
                {props.children}
                <AddFieldList index={index} controlId={controlId} properties={properties} status={status}
                              hiddenPropertyNames={hiddenPropertyNames} displayOnlyPropertyNames={displayOnlyPropertyNames}
                              activeEventKey={activeEventKey} predefinedOptionProperties={predefinedOptionProperties} />
                <AcceptReject controlId={controlId} />
            </EnhancedAccordionBody>
        </Accordion.Item>
    )
}

AddAccordionItem.propTypes = {
    index: PropTypes.number.isRequired,
    controlId: PropTypes.string.isRequired,
    properties: PropTypes.array.isRequired,
    header:PropTypes.string.isRequired
}
export default AddAccordionItem